import Api from '../Api';

export const getFabricStocks = () => async dispatch => {
  const { data } = await Api.get('/fabric-inventory/stocks');

  dispatch({
    type: 'FETCH_FABRIC_STOCKS',
    payload: data,
  });
};

export const clearFabricStocks = () => {
  return {
    type: 'CLEAR_FABRIC_STOCKS',
  };
};

export const getFabricInventory = () => async dispatch => {
  const { data } = await Api.get('/fabric-inventory');

  dispatch({
    type: 'FETCH_FABRIC_INVENTORY',
    payload: data,
  });
};

export const clearFabricInventory = () => {
  return {
    type: 'CLEAR_FABRIC_INVENTORY',
  };
};

export const getFabricInventoryStats = () => async dispatch => {
  const { data } = await Api.get('/fabric-inventory/stats');

  dispatch({
    type: 'FETCH_FABRIC_INVENTORY_STATS',
    payload: data,
  });
};

export const clearFabricInventoryStats = () => {
  return {
    type: 'CLEAR_FABRIC_INVENTORY_STATS',
  };
};

export const getFabricsForJobchart = () => async dispatch => {
  const { data } = await Api.get('/fabric-inventory/fabricsforjobchart');

  dispatch({
    type: 'FETCH_FABRICS_FOR_JOBCHART',
    payload: data,
  });
};

export const clearFabricsForJobchart = () => {
  return {
    type: 'CLEAR_FABRICS_FOR_JOBCHART',
  };
};

export const getSingleFabricInfo = id => async dispatch => {
  const { data } = await Api.get(`/fabric-inventory/${id}`);

  dispatch({
    type: 'FETCH_SINGLE_FABRIC_INFO',
    payload: data,
  });
};

export const clearSingleFabricInfo = () => {
  return {
    type: 'CLEAR_SINGLE_FABRIC_INFO',
  };
};

export const getSingleFabricInfoToTransfer = id => async dispatch => {
  const { data } = await Api.get(`/fabric-inventory/${id}/transfer`);

  dispatch({
    type: 'FETCH_SINGLE_FABRIC_INFO_TO_TRANSFER',
    payload: data,
  });
};

export const clearSingleFabricInfoToTransfer = () => {
  return {
    type: 'CLEAR_SINGLE_FABRIC_INFO_TO_TRANSFER',
  };
};

export const getFabricTransferHistory = fabricInventoryId => async dispatch => {
  const { data } = await Api.get(
    `/fabric-inventory/transfer/list`,
    fabricInventoryId
  );

  dispatch({
    type: 'FETCH_FABRIC_TRANSFER_HISTORY',
    payload: data,
  });
};

export const clearFabricTransferHistory = () => {
  return {
    type: 'CLEAR_FABRIC_TRANSFER_HISTORY',
  };
};

export const getJobchartFabricsForRpo = jobchartId => async dispatch => {
  const { data } = await Api.get(
    `/fabric-inventory/jobchartfabricsforrpo/${jobchartId}`
  );

  dispatch({
    type: 'FETCH_JOBCHART_FABRICS_FOR_RPO',
    payload: data,
  });
};

export const clearJobchartFabricsForRpo = () => {
  return {
    type: 'CLEAR_JOBCHART_FABRICS_FOR_RPO',
  };
};

export const getFabricStocksForOutward =
  (rpoId, params = {}) =>
  async dispatch => {
    const { data } = await Api.get(
      `/fabric-inventory/stocksforoutward/${rpoId}`,
      params
    );

    dispatch({
      type: 'FETCH_FABRIC_STOCKS_FOR_OUTWARD',
      payload: data,
    });
  };

export const clearFabricStocksForOutward = () => {
  return {
    type: 'CLEAR_FABRIC_STOCKS_FOR_OUTWARD',
  };
};

export const getPendingFabricTransferRequestCount = () => async dispatch => {
  const { data } = await Api.get(`/fabric-inventory/pendingcount`);

  dispatch({
    type: 'FETCH_PENDING_FABRIC_TRANSFER_REQUEST_COUNT',
    payload: data,
  });
};

export const clearPendingFabricTransferRequestCount = () => ({
  type: 'CLEAR_PENDING_FABRIC_TRANSFER_REQUEST_COUNT',
});
